export const styles = {
  thermostatIcon: { color: "#7E7E7E" },
  appIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    px: 1,
  }
}
